import { createElement } from 'react';
import {
  ILabel,
  IRenderContext,
  LabelStyleBase,
  Size,
  SvgVisual,
  Visual,
} from '@ardoq/yfiles';
import {
  ArdoqLabelStyleElement,
  ADD_TO_SCENARIO_BUTTON_HEIGHT,
  ADD_TO_SCENARIO_BUTTON_WIDTH,
} from './ArdoqLabelStyleElement';
import { dataModelId } from 'tabview/graphComponent/graphComponentUtil';
import { createSvgElement } from '@ardoq/dom-utils';
import { ensureRoot, disposeCallback } from '@ardoq/graph';

const renderAddToScenarioLabel = (
  _context: IRenderContext,
  container: SVGElement,
  label: ILabel
) => {
  const componentId = dataModelId(label.tag);
  if (!componentId) return;
  ensureRoot(container).render(
    createElement(ArdoqLabelStyleElement, { componentId })
  );
};

export class ArdoqAddToScenario extends LabelStyleBase {
  override createVisual(context: IRenderContext, label: ILabel) {
    const g = createSvgElement('g');

    renderAddToScenarioLabel(context, g, label);
    LabelStyleBase.createLayoutTransform(context, label.layout, true).applyTo(
      g
    );
    const result = new SvgVisual(g);
    context.setDisposeCallback(result, disposeCallback);
    return result;
  }

  override updateVisual(
    context: IRenderContext,
    oldVisual: Visual,
    label: ILabel
  ) {
    const svgVisual = oldVisual as SvgVisual;
    const g = svgVisual.svgElement as SVGGElement;
    LabelStyleBase.createLayoutTransform(context, label.layout, true).applyTo(
      g
    );
    return oldVisual;
  }

  override getPreferredSize() {
    return new Size(
      ADD_TO_SCENARIO_BUTTON_WIDTH,
      ADD_TO_SCENARIO_BUTTON_HEIGHT
    );
  }
}
